import { ScreenOrientation, OrientationLockType } from '@capacitor/screen-orientation'
import { useCallback, useEffect, useState } from 'react'

export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<OrientationLockType>('natural')

  const getOrientation = useCallback(async () => {
    const orientationResult = await ScreenOrientation.orientation()
    setOrientation(orientationResult.type)
  }, [])

  useEffect(() => {
    void ScreenOrientation.addListener('screenOrientationChange', () => {
      void getOrientation()
    })
    return () => {
      void ScreenOrientation.removeAllListeners()
    }
  }, [])

  return orientation
}
